import React from 'react';
import { AppSidebarView } from './AppSidebarView';
import ViewsNavigationSection from '../../../features/views/components/ViewsNavigationSection';
import { useInbox } from '../../../features/agents/hooks';
import { needsYouCountOf } from '../../../features/agents/needsYouCount';
import { useBranchChangeMarkers } from '../../../features/sandbox/hooks/useBranchChangeMarkers';

const liveQueries = { useBranchChangeMarkers, useInbox, views: undefined };

export default function AppSidebar({ queries: suppliedQueries = {}, viewingAs = false, ...props }) {
  const queries = { ...liveQueries, ...suppliedQueries };
  const { hasPageChanges } = queries.useBranchChangeMarkers();
  // The questions and cards waiting on the person: the count Home, the bell and the agent strip show.
  // While viewing as someone, the Superadmin's own count is not theirs.
  const inboxCount = needsYouCountOf(queries.useInbox().data);
  const needsYouCount = viewingAs ? 0 : inboxCount;
  return (
    <AppSidebarView
      {...props}
      hasPageChanges={hasPageChanges}
      needsYouCount={needsYouCount}
      renderViewsNavigation={(viewProps) => (
        <ViewsNavigationSection {...viewProps} queries={queries.views} />
      )}
    />
  );
}
